import { RootStateModel } from '../models/root-state.model';

export const loadingErrorMatcher = (state: RootStateModel) => {
  state.isLoading = false;
};
